import moment from "moment";

export const RULE_CONFIGURATION_STATUS = {
  live: "live",
  draft: "draft",
  archived: "archived",
};

export const highlightGenerationStages = {
  add_to_highlight: "add_to_highlight",
  save_as_clip: "save_as_clip",
  highlight_generated: "highlight-generated",
};

export const ruleConfigurationUIStepTypes = {
  setup: "setup",
  addStep: "addStep",
  brightcove_publish: "brightcove_publish",
  send_mail: "send_mail",
  filters: "filters",
  highlight_generation: "highlight_generation",
  social_media_publish: "social_media_publish",
  cloud_publish: "cloud_publish",
  aspect_ratio: "aspect_ratio",
};

export const streamStatusLabel = {
  1: "Match End",
  2: "During Match",
};

export const ruleContentType = {
  clip: "clip",
  highlight: "highlight",
};

export const stepTransformerTypes = {
  highlightGeneration: "highlightGeneration",
  populateStepsWithContentType: "populateStepsWithContentType",
  socialMediaPublish: "socialMediaPublish",
  email: "email",
  aspectRatio: "aspectRatio",
};

export const ruleConfigurationUISteps = {
  [ruleConfigurationUIStepTypes.setup]: {
    label: "Automation Setup: When, What, and Type",
    icon: "components/v2/RuleConfigurationDetails/RuleConfigurationStepsCard/RuleWhenStepCard.svg",
  },
  [ruleConfigurationUIStepTypes.send_mail]: {
    label: "Send an Email",
    icon: "components/v2/RuleConfigurationDetails/RuleConfigurationStepsCard/RuleEmailStepCard.svg",
  },
  [ruleConfigurationUIStepTypes.cloud_publish]: {
    label: "Publish on cloud",
    icon: "components/v2/RuleConfigurationDetails/RuleConfigurationStepsCard/RuleEmailStepCard.svg",
  },
  [ruleConfigurationUIStepTypes.social_media_publish]: {
    label: "Publish on social media",
    icon: "components/v2/RuleConfigurationDetails/RuleConfigurationStepsCard/RuleEmailStepCard.svg",
  },
  [ruleConfigurationUIStepTypes.aspect_ratio]: {
    label: "Aspect ratio",
    icon: "components/v2/RuleConfigurationDetails/RuleConfigurationStepsCard/RuleAspectRatioCardIcon.svg",
  },
  [ruleConfigurationUIStepTypes.filters]: {
    label: "Add Filters",
    icon: "components/v2/RuleConfigurationDetails/RuleConfigurationStepsCard/RuleFilterStepCard.svg",
  },
  [ruleConfigurationUIStepTypes.highlight_generation]: {
    label: "Highlight (Package) Generation",
    icon: "components/v2/RuleConfigurationDetails/RuleConfigurationStepsCard/RuleHighlightStepCard.svg",
  },
  [ruleConfigurationUIStepTypes.brightcove_publish]: {
    label: "BrightCove Publish",
    icon: "components/v2/PublishedPlatforms/brightcove.svg",
  },
};

export const emailLanguageMap = {
  en: "English",
  jp: "Japanese",
};

export const ruleConfigurationTypes = {
  clip: "Clip",
  clipList: "Highlight",
};

export const ruleEngineGroupTypes = {
  all: "AND",
  any: "OR",
};

export const formatRuleExecutionDate = (dateString) => {
  const executionDate = moment(dateString);
  return `Executed ${executionDate.fromNow()}`;
};

export const factConditionTypes = {
  events: "events",
  players: "players",
  highlightGeneration: "highlightGeneration",
  clipRating: "clipRating",
  clipAspectRatio: "clipAspectRatio",
  tournamentName: "tournamentName",
  homeTeamName: "homeTeamName",
  awayTeamName: "awayTeamName",
  streamTitle: "streamTitle",
  streamId: "streamId",
  clipDateCreation: "clipDateCreation",
  unhandled: "unhandled",
};

export const highlightSaveStatus = {
  draft: "Draft",
  generate: "Generate",
  save_as_clip: "Save as Clip",
};

export const highlightSortingTypes = {
  "Creation Time": "CREATION_TIME",
  "No Sorting": "NO_SORTING",
  "Start Time": "START_TIME",
};

export const highlightSortingUITypes = {
  creationTime: "Creation Time",
  noSorting: "No Sorting",
  startTime: "Start Time",
};

export const DEFAULT_RULE_TITLE = "New Rule";
export const CLIPLIST = "clipList";

export const stepConstantsForTests = {
  setup: "setup",
  setup_highlight: "setup_highlight",
  filter: "filter",
  highlight_filter: "highlight_filter",
  highlight: "highlight",
  mail: "mail",
  cloud_publish: "cloud_publish",
};

export const statusConstantsForTests = {
  draft: "Draft",
  generate: "Generate",
  save_as_clip: "Save as Clip",
};

export const contentTypesForTests = {
  clips: "clips",
  highlights: "highlights",
};

export const generateHighlightSortingTypesForTests = {
  creationTime: "CREATION_TIME",
  noSorting: "NO_SORTING",
  startTime: "START_TIME",
};

export const generateHighlightSortingUITypesForTests = {
  creationTime: "Creation Time",
  noSorting: "No Sorting",
  startTime: "Start Time",
};

export const formatRuleExecutionTimeFromNow = (time) => {
  const executionTime = moment(time);
  if (executionTime.isValid()) {
    return `${executionTime.fromNow()}`;
  }
  return "Never";
};

export const MAX_DEFAULT_HL_DURATION = 45;

export const croppingMethod = {
  autoFlip: "autoFlip",
  centerCrop: "centerCrop",
};
